import { EFuelGrade, EFuelType } from '@/config/station';

import {
  extractAddress as readAddress,
  extractTransactionCost as readTransactionCost,
  extractTransactionSummary as readTransactionSummary,
  gradeToDisplayKey as readGradeKey,
  typeToDisplayKey as readTypeKey,
} from '@/components/evTransactions/transactionUtils';

import type { TOption } from '@/types/common';

/**
 * Text helpers and the summary now live in `@/components/evTransactions/transactionUtils`
 * (shared with the site page EV Transactions List). They are re-exported here because other
 * pages (add pump, fuel details, customers, payments, members) import them from this file.
 * Assigned exports stay visible to the dev server. A bare `export { name }` does not.
 */
export const extractAddress = readAddress;
export const extractTransactionCost = readTransactionCost;
export const extractTransactionSummary = readTransactionSummary;
export const gradeToDisplayKey = readGradeKey;
export const typeToDisplayKey = readTypeKey;

export const FUEL_TYPE_FILTER_OPTIONS: TOption<EFuelType>[] = [
  { value: EFuelType.GASOLINE, label: typeToDisplayKey(EFuelType.GASOLINE) },
  { value: EFuelType.DIESEL, label: typeToDisplayKey(EFuelType.DIESEL) },
  { value: EFuelType.ELECTRIC, label: typeToDisplayKey(EFuelType.ELECTRIC) },
];

export const FUEL_GRADE_FILTER_OPTIONS: TOption<EFuelGrade>[] = [
  { value: EFuelGrade.REGULAR, label: gradeToDisplayKey(EFuelGrade.REGULAR) },
  { value: EFuelGrade.MID_GRADE, label: gradeToDisplayKey(EFuelGrade.MID_GRADE) },
  { value: EFuelGrade.PREMIUM, label: gradeToDisplayKey(EFuelGrade.PREMIUM) },
  { value: EFuelGrade.DIESEL, label: gradeToDisplayKey(EFuelGrade.DIESEL) },
];
